import { hasSoftDeployAccess } from 'App/services/FeatureHelperStandalone';

export default function ContactCardAllowed() {
	return hasSoftDeployAccess('REACT_CONTACT_CARD');
}
